var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as types from './types';
import * as statuses from '../../states';
var initialState = {
    creation: statuses.IDLE,
    status: statuses.IDLE,
    error: null,
    total: 0,
    data: [],
};
export default function partnerReducer(state, actions) {
    if (state === void 0) { state = initialState; }
    var type = actions.type, payload = actions.payload;
    switch (type) {
        case types.CREATE_PARTNER_REQUEST:
            return __assign(__assign({}, state), { creation: statuses.LOADING });
        case types.CREATE_PARTNER_SUCCEEDED:
            return __assign(__assign({}, state), { creation: statuses.IDLE, data: __spreadArray(__spreadArray([], state.data, true), [payload], false) });
        case types.CREATE_PARTNER_FAILED:
            return __assign(__assign({}, state), { creation: statuses.FAIL, error: payload });
        case types.FETCH_PARTNERS_REQUEST:
            return __assign(__assign({}, state), { status: statuses.IDLE });
        case types.FETCH_PARTNERS_SUCCEEDED:
            if (!payload || typeof payload === 'number' || !('data' in payload))
                return;
            return __assign(__assign({}, state), { data: payload.data, total: payload.total, status: statuses.SUCCESS });
        case types.FETCH_PARTNERS_FAILED:
            return __assign(__assign({}, state), { status: statuses.FAIL, error: payload });
        default:
            return state;
    }
}
